<h6 class="montserrat-medium text-gray-500 mb-4">Are you sure you want to delete this campaign?</h6>
<div class="d-flex align-items-center justify-content-center">
    <button class="btn btn-md btn-outline-gray-500 mr-3" mat-dialog-close>cancel</button>
    <button (click)="deleteCampaign()" class="btn btn-md btn-gray-500">delete</button>
</div>
